import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";

import { handleSubmit, classNames } from "../../../../auxiliar/auxFunctions";

const OverviewTable = ({
    data,
    navigate,
    columns,
    getRowData,
    getDetailPath,
    renderActions,
    className = "",
    actionsWidth = "w-[10%]",
    noTruncateColumns = [], // Array of column indices that should not be truncated
}) => {
    const [isVisible, setIsVisible] = useState(true);
    const [currentData, setCurrentData] = useState(data);

    // Check if any column has width specified
    const hasFixedWidths = columns.some((column) => column.width);

    // Check if we should show actions column
    const shouldShowActions = getDetailPath || renderActions;

    useEffect(() => {
        if (data.order !== currentData.order) {
            setIsVisible(false);
            setTimeout(() => {
                setCurrentData(data);
                setIsVisible(true);
            }, 150);
        }
    }, [data, currentData]);

    return (
        <div
            className={`hidden lg:block bg-base-100 rounded-xl shadow-md shadow-primary/5 border border-base-300 overflow-visible ${className}`}
        >
            <table className={`table w-full ${hasFixedWidths ? "table-fixed" : ""}`}>
                <thead className="bg-primary/15">
                    <tr className="border-base-300 [&_th:first-child]:rounded-tl-xl [&_th:last-child]:rounded-tr-xl">
                        {columns.map((column, index) => (
                            <th
                                key={index}
                                className={`font-semibold text-base-content/80 py-3 ${classNames(column.align, column.width, column.cellClass)}`}
                            >
                                {column.icon ? (
                                    <div className="flex items-center gap-2">
                                        <FontAwesomeIcon
                                            icon={column.icon}
                                            className="text-base-content/40"
                                        />
                                        {/* Don't truncate labels that might contain tooltips */}
                                        {column.label}
                                    </div>
                                ) : (
                                    column.label
                                )}
                            </th>
                        ))}
                        {shouldShowActions && (
                            <th
                                className={`font-semibold text-base-content/80 py-3 text-center
                                ${hasFixedWidths ? actionsWidth : ""}`}
                            >
                                Acciones
                            </th>
                        )}
                    </tr>
                </thead>
                <tbody
                    className={`transition-opacity duration-150 ${isVisible ? "opacity-100" : "opacity-0"}`}
                >
                    {currentData.order.map((id, rowIndex) => {
                        const item = currentData.content && currentData.content[id];
                        const rowData = getRowData(item, id);
                        const isLastRow = rowIndex === currentData.order.length - 1;

                        return (
                            <tr
                                key={id}
                                className="border-base-300 hover:bg-primary/8 transition-colors duration-150"
                            >
                                {rowData.map((cellData, index) => {
                                    const isFirstCell = index === 0;
                                    const isLastCell =
                                        index === rowData.length - 1 && !shouldShowActions;

                                    return (
                                        <td
                                            key={index}
                                            className={`py-3 overflow-visible ${columns[index]?.cellClass || ""} ${columns[index]?.width || ""} ${
                                                isLastRow && isFirstCell ? "rounded-bl-xl" : ""
                                            } ${isLastRow && isLastCell ? "rounded-br-xl" : ""}`}
                                        >
                                            <div
                                                className={
                                                    hasFixedWidths &&
                                                    !noTruncateColumns.includes(index)
                                                        ? "truncate"
                                                        : ""
                                                }
                                            >
                                                {cellData}
                                            </div>
                                        </td>
                                    );
                                })}
                                {shouldShowActions && (
                                    <td
                                        className={`py-3 text-center ${hasFixedWidths ? actionsWidth : ""} ${
                                            isLastRow ? "rounded-br-xl" : ""
                                        }`}
                                    >
                                        {renderActions ? (
                                            renderActions(item, id)
                                        ) : (
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm"
                                                onClick={handleSubmit(navigate, getDetailPath(id))}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faEye}
                                                    className="2xl:mr-2"
                                                />
                                                <span className="hidden 2xl:inline">Detalles</span>
                                            </button>
                                        )}
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default OverviewTable;
